

export const currentTenant = {  
  id: 'jeevawasa',
  name: 'Jeevawasa Resort',
  // Domain yang akan dikirim sebagai X-Tenant-Domain header
  // Ini yang menentukan database mana yang diakses backend
  domain: 'omni-hotelier.mymembership.id', 

  // Gunakan IP untuk development agar real device bisa akses
  // Backend akan initialize tenant berdasarkan X-Tenant-Domain header
  apiHost: 'https://api.mymembership.id',  

  primaryColor: '#4DBA87',
  
  secondaryColor: '#ffffff',
};

// Helper function untuk get merchant ID dengan fallback
export const getMerchantId = () => {
  const envMerchantId = process.env.VUE_APP_MERCHANTID_APP;
  

  
  return envMerchantId;
};

export const isDevelopment = () => {
  return process.env.NODE_ENV === 'development';
};

export const getApiHost = () => {
  if (currentTenant.apiHost) {
    return currentTenant.apiHost;
  }
  return process.env.VUE_APP_API_HOST || 'https://app.mymembership.id';
};

export default currentTenant;
